export default function($) {

  var IwProductVariationPreview = function(element){
    this.current_variation_preview = element

    // ui modal nodes
    this.modal = element.closest('.js-iw-product-wrapper').find('.js-iw-preview-modal')
    this.modal_image = this.modal.find('.js-iw-preview-modal--img')
    this.modal_caption = this.modal.find('.js-iw-preview-modal--caption')
    this.modal_before_button = this.modal.find('.js-iw-preview-modal--previous')
    this.modal_next_button = this.modal.find('.js-iw-preview-modal--next')
    this.modal_close_button = this.modal.find('.js-iw-preview-modal--close')

    // ui label
    this.previous_label = "<"
    this.next_label = ">"
    this.close_label = "x"

    // navigation
    this.previous_variation_preview = this.current_variation_preview
                                          .closest('.js-iw-product-variation')
                                          .prev('.js-iw-product-variation')
                                          .find('.js-iw-preview-img')
    this.next_variation_preview = this.current_variation_preview
                                      .closest('.js-iw-product-variation')
                                      .next('.js-iw-product-variation')
                                      .find('.js-iw-preview-img')

    // current element props
    this.has_previous = this.previous_variation_preview.length > 0
    this.has_next = this.next_variation_preview.length > 0
    this.alt = element.data("alt")
    this.caption = element.data("caption")
    this.large_image_src = element.data("large-image-src")

    var self = this

    this.current_variation_preview.parent(".js-iw-img-preview-trigger").click(function(event) {
      event.preventDefault()
      self.init()
    })
  }

  IwProductVariationPreview.prototype = {
    init: function() {
      var self = this
      // watchers
      if (this.has_previous) {
        this.modal_before_button.click(function(event) {
          self.previous()
        })
      }

      if (this.has_next) {
        this.modal_next_button.click(function(event) {
          self.next()
        })
      }

      this.modal_close_button.click(function(event) {
        self.close()
      })

      // ui
      this.render("init")
    },
    previous: function() {
      this.close()
      this.previous_variation_preview.trigger('click')
    },
    next: function() {
      this.close()
      this.next_variation_preview.trigger('click')
    },
    close: function() {
      if (this.has_previous) {
        this.modal_before_button.unbind()
      }
      if (this.has_next) {
        this.modal_next_button.unbind()
      }
      this.modal_close_button.unbind()

      this.render("close");
    },
    render: function(action, data="") {
      switch(action) {
        case "init":
          this.modal_image.attr("src", this.large_image_src)
          this.modal_image.attr("alt", this.alt)
          this.modal_caption.text(this.caption)

          this.has_previous ?
            this.modal_before_button.text(this.previous_label) :
            this.modal_before_button.text("")

          this.has_next ?
            this.modal_next_button.text(this.next_label) :
            this.modal_next_button.text("")

          this.modal_close_button.text(this.close_label)

          this.modal.show()
          break;
        case "close":
          this.modal.hide()
          break;
      }
    },
  }


  $(document).ready(function () {
    if ( $('.js-iw-preview-modal').length ) {
      var iwProductVariationPreview = $('.js-iw-preview-img');
      // we do nothing is the selector is not found
      if (iwProductVariationPreview.length) {
        iwProductVariationPreview.each(function () {
          var iwpvp = new IwProductVariationPreview($(this));
        })
      }
    }
  })

}
